import { render, staticRenderFns } from "./VideoPlayerDialog.vue?vue&type=template&id=709097b9&scoped=true"
import script from "./VideoPlayerDialog.vue?vue&type=script&lang=js"
export * from "./VideoPlayerDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerDialog.vue?vue&type=style&index=0&id=709097b9&prod&lang=scss&scoped=true"
import style1 from "./VideoPlayerDialog.vue?vue&type=style&index=1&id=709097b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709097b9",
  null
  
)

export default component.exports